import type { ApiErrorBody } from './types'

/**
 * 서버가 준 오류를 그대로 나르는 예외.
 *
 * `message` 는 **서버가 준 사용자용 문구**다. 화면은 이것을 그대로 보여준다.
 * "오류가 발생했습니다" 로 뭉개면 원인을 찾을 수 없다 (CLAUDE.md 7).
 */
export class ApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
    readonly fields: Record<string, string> = {},
    readonly extra: Record<string, unknown> = {},
  ) {
    super(message)
    this.name = 'ApiError'
  }

  static fromBody(body: ApiErrorBody, status: number): ApiError {
    const { code, message, fields, ...rest } = body.error

    return new ApiError(
      code,
      message,
      status,
      (fields as Record<string, string> | undefined) ?? {},
      rest as Record<string, unknown>,
    )
  }

  /** 네트워크가 끊겼거나 서버가 봉투 없이 죽은 경우. */
  static transport(message: string, status = 0): ApiError {
    return new ApiError('NETWORK_ERROR', message, status)
  }

  isValidation(): boolean {
    return 'VALIDATION_FAILED' === this.code
  }

  /** 필드 오류 중 하나를 꺼낸다. 폼에 붙일 때 쓴다. */
  fieldError(name: string): string | undefined {
    return this.fields[name]
  }
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError
}
